import { Button } from "@quest/ui/components/button";
import { AlertTriangle, RefreshCw } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

function ErrorPage() {
  const { t } = useTranslation("Common");
  const [isReloading, setIsReloading] = useState(false);

  const handleHardReload = async () => {
    setIsReloading(true);

    try {
      // 1. Clear all Cache Storage entries (if the app uses the Cache API / service workers)
      if ("caches" in window) {
        const keys = await caches.keys();
        await Promise.all(keys.map((key) => caches.delete(key)));
      }

      // 2. Unregister any service workers
      if ("serviceWorker" in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(registrations.map((reg) => reg.unregister()));
      }
    } catch (err) {
      // Non-fatal — proceed to reload regardless
      console.error("Failed to clear caches before reload:", err);
    }

    // 3. Force a fresh network fetch of the current URL, bypassing the HTTP cache.
    //    location.reload(true) is deprecated/non-standard, so instead we
    //    navigate to a cache-busted URL to guarantee a fresh response.
    const url = new URL(window.location.href);
    url.searchParams.set("_reload", Date.now().toString());
    window.location.replace(url.toString());
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md rounded-xl border border-red-200 bg-white p-8 text-center shadow-sm">
        <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
          <AlertTriangle className="h-8 w-8 text-red-600" />
        </div>

        <h1 className="text-2xl font-semibold text-gray-900">
          {t("somethingWentWrong")}
        </h1>

        <p className="mt-3 text-sm leading-6 text-gray-600">
          {t("errorPageDescription")}
        </p>

        <Button
          onClick={handleHardReload}
          disabled={isReloading}
          className="mt-6 inline-flex w-full items-center justify-center gap-2"
        >
          <RefreshCw
            className={`h-4 w-4 ${isReloading ? "animate-spin" : ""}`}
          />
          {isReloading ? t("reloading") : t("reloadPage")}
        </Button>
      </div>
    </div>
  );
}

export default ErrorPage;
